import React from "react";
import CompanyDepartmentsTable from "./CompanyDepartmentsTable";

const CompanyDepartments = () => {
  return (
    <div>
      <CompanyDepartmentsTable />
    </div>
  );
};

export default CompanyDepartments;
